<template>
 <v-app>
   <router-view/>
  </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@font-face {
  font-family: "Kanit";
  src: local("Kanit"),
   url(./forn/Kanit-Regular.ttf) format("truetype");
}
:root {
  --nav-text: #B61C1C;
  --table-head-bg: #B61C1C;
  --table-head-text: #ffffff;
  --table-body-row-even: #DAE4F1;
  --table-body-row-odd: #ffffff;
  --table-body-text: #1B437C;
}
/* .v-data-table-header {
  background-color: var(--table-head-bg) !important;
} */
.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  color: var(--table-head-text) !important;
}
.v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 8px 5px 8px 15px !important;
}
.v-data-table>.v-data-table__wrapper>table>tbody>tr:nth-child(even) {background: var(--table-body-row-even)}
.v-data-table>.v-data-table__wrapper>table>tbody>tr:nth-child(odd) {background: var(--table-body-row-odd)}
.v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  color: var(--table-body-text) !important;
}
.theme--light.v-data-table .v-data-table-header th.sortable.active, .theme--light.v-data-table .v-data-table-header th.sortable.active .v-data-table-header__icon, .theme--light.v-data-table .v-data-table-header th.sortable:hover {
  color: var(--table-head-text) !important;
}
.theme--light.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
  color: var(--table-head-text) !important;
}
.menu-head {
  color: var(--nav-text) !important;
  font-size: 35px !important;
}
.v-img-margit {
  width: 239px;
  height: 28px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue